import { X } from "lucide-react";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./dialog";
import React from "react";


const ModalPopup = ({
  open,
  onClose,
  title,
  description,
  children,
  actionButton,
  className = "",
  width = "w-[35%]",
  isCloseIconNeeded = true,
  containerRef
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        containerRef={containerRef}
        className={` ${width} ${className} sm:rounded-lg bg-primary-foreground shadow-xl border`}
      >
        {title && <DialogHeader className={'grow-0'}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <DialogTitle className="text-lg text-foreground font-semibold">{title}</DialogTitle>
            {isCloseIconNeeded &&
              <DialogClose asChild>
                <button className="rounded-sm p-1 opacity-70 hover:opacity-100 focus:outline-none">
                  <X className="h-4 w-4" />
                  <span className="sr-only">Close</span>
                </button>
              </DialogClose>
            }
          </div>
          {description && (
            <DialogDescription className="font-sans text-sm text-gray-500">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>}

        <div className="space-y-1">{children}</div>

        {actionButton && (
          <DialogFooter>
            {actionButton}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalPopup;